import React from 'react';
import { Link } from 'gatsby';
import { LocaleContext } from './layout';
import locales from '../../config/i18n';

interface LocalizedLinkProps {
    to: string;
    [key: string]: any;
}

interface LocaleContextValue {
    locale: string;
}

// Use the globally available context to choose the right path
const LocalizedLink = ({ to, ...props }: LocalizedLinkProps) => {
    const { locale } = React.useContext(LocaleContext) as LocaleContextValue;

    const isIndex = to === `/`;

    // If it's the default language, don't do anything
    // If it's another language, add the "path"
    // However, if the homepage/index page is linked don't add the "to"
    // Because otherwise this would add a trailing slash
    let path = locales[locale].default ? to : `/${locales[locale].path}${isIndex ? `` : `${to}`}`;

    const regexString = /(.*)[^/]$/;
    let hasNoSlash = regexString.test(path);
    if (hasNoSlash) {
        if (!path.includes('#')) {
            path = path + '/';
        }
    }

    return <Link {...props} to={path} />;
};

export default LocalizedLink;
